import { useEffect } from 'react';
import { prefetchRepo } from '../api/client';

/**
 * 全局：对带 data-repo-path 的链接在 hover 时预取 repo + branches，首次点击即可命中缓存。
 */
export function PrefetchRepoOnHover() {
    useEffect(() => {
        const onMouseEnter = (e: MouseEvent) => {
            const target = (e.target as Element).closest?.('a[data-repo-path]');
            if (target instanceof HTMLAnchorElement && target.dataset.repoPath) {
                prefetchRepo(target.dataset.repoPath);
            }
        };
        document.addEventListener('mouseenter', onMouseEnter, true);
        return () => document.removeEventListener('mouseenter', onMouseEnter, true);
    }, []);
    return null;
}
